import ShUserAvatarUpload from '@/components/Helpers/ShUserAvatarUpload';
import ShButton from '@/components/Helpers/ShButton';

// @vue/component
export default {
  name: 'AgentDetails',

  components: {
    ShButton,
    ShUserAvatarUpload,
  },

  props: {
    agent: {
      type: Object,
      default: () => ({}),
      require: true,
    },
  },

  data() {
    return {
      agentAvatar: this.agent.avatar,
      isNameEdited: false,
      isNumberEdited: false,
      isExternalNameEdited: false,
      agentName: this.agent.name,
      agentNumber: null,
      agentExternalName: this.agent.external_name,
    };
  },

  computed: {
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'agents/update',
        'agents/deleteAvatar',
        'numbers/getList',
      ]);
    },
    availableNumbersList() {
      return this.$store.getters['numbers/list'].filter(number => !number.assigned_to_agent_id && number.is_verified);
    },
  },

  methods: {
    async handleUploadAvatar(avatar) {
      const params = {
        id: this.agent.id,
        avatar,
      };

      await this.$store.dispatch('agents/update', params);
      await this.$store.dispatch('numbers/getList');
      this.$store.dispatch('agents/getList');
      this.agentAvatar = avatar;
      this.$notify.success({
        title: 'Zmiana danych',
        message: 'Nowe dane Konsultanta zapisane poprawnie',
        customClass: 'callmeweb-notification',
      });
    },
    async handleDeleteAvatar() {
      const params = {
        id: this.agent.id,
      };
      await this.$store.dispatch('agents/deleteAvatar', params);
      await this.$store.dispatch('numbers/getList');
      this.$emit('closeModal');
      this.$store.dispatch('agents/getList');
      this.$notify.success({
        title: 'Usunięcie avatara',
        message: 'Usunięto avatar użytkownika',
        customClass: 'callmeweb-notification',
      });
    },
    handleCancelEditAgentName() {
      this.agentName = this.agent.name;
      this.isNameEdited = false;
    },
    handleCancelEditAgentExternalName() {
      this.agentExternalName = this.agent.external_name;
      this.isExternalNameEdited = false;
    },
    async handleSaveEditAgentName() {
      const params = {
        id: this.agent.id,
        name: this.agentName,
        external_name: this.agentExternalName,
      };
      await this.$store.dispatch('agents/update', params);
      this.isNameEdited = false;
      this.isExternalNameEdited = false;
      await this.$store.dispatch('numbers/getList');
      this.$store.dispatch('agents/getList');
    },
    async handleSaveEditAgentNumber() {
      const params = {
        id: this.agent.id,
        number_id: this.agentNumber,
      };
      await this.$store.dispatch('agents/update', params);
      await this.$store.dispatch('numbers/getList');
      this.$store.dispatch('agents/getList');
      this.isNumberEdited = false;
    },
  },
};
